export default "__VITE_ASSET__$5IooMNx__"